module.exports = __webpack_public_path__ + "img/lucky-id.ebae6a67.png";